{
  "common.close": "Bezárás",
  "common.athleteFallback": "sportoló: {id}",
  "splash.title": "{app} — animált tevékenységvizualizáció",
  "splash.tagline": "Strava-adataid&nbsp;mozgásban",
  "splash.demo": "Bemutató",
  "tab.query.title": "Térkép: {name}",
  "tab.query.heading": "Tevékenységek lekérése:",
  "tab.query.optDays": "utolsó napok",
  "tab.query.optActivities": "utolsó tevékenységek",
  "tab.query.optIds": "Tevékenységazonosítók",
  "tab.query.optDates": "Dátumtartomány",
  "tab.query.idsPlaceholder": "ide írd a tevékenységazonosítókat",
  "tab.query.after": "Ettől:",
  "tab.query.before": "Eddig:",
  "tab.query.autozoom": "Importálás után automatikus nagyítás <i class=\"hf hf-bullseye\"></i> a találatokra",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Lekérés",
  "tab.query.createAccount": "Hozz létre fiókot és/vagy jelentkezz be.",
  "tab.query.sports": "Sportágak:",
  "tab.query.allSports": "Minden sportág",
  "tab.query.sportsExcept": "Mind, kivéve",
  "tab.query.sportsNone": "Egyik sem",
  "tab.query.loadingSports": "Sportágak betöltése…",
  "tab.query.sportsFailed": "Nem sikerült betölteni a térkép sportágait",
  "tab.query.noSports": "Még nincs tevékenység",
  "tab.activities.title": "Megjelenített tevékenységek",
  "tab.activities.clearSelection": "Kijelölés törlése",
  "tab.activities.renderSelected": "Kijelöltek megjelenítése",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Nagyítás a kijelölésre",
  "tab.controls.title": "Rétegbeállítások",
  "tab.controls.timescale": "Időskála <i>&tau;</i>",
  "tab.controls.timescaleHint": "lejátszási sebesség",
  "tab.controls.period": "Periódus <i>T</i>",
  "tab.controls.periodHint": "tevékenység ~ modell",
  "tab.controls.dotSize": "Pontméret",
  "tab.controls.pathWidth": "Vonalvastagság",
  "tab.controls.pathWidthHint": "nulla elrejti a vonalakat",
  "tab.controls.colors": "Színek",
  "tab.controls.colorsHint": "paletta forgatása",
  "tab.controls.shadows": "Árnyékok",
  "tab.profile.loginTitle": "Bejelentkezés",
  "tab.profile.anonNote": "Jelentkezz be a Stravával, hogy lásd a saját tevékenységeidet és kezeld a Heatflask-fiókodat.",
  "tab.profile.loginLink": "Bejelentkezés a Stravával",
  "tab.profile.editOnStrava": "Profilod szerkesztése a Stravában",
  "tab.profile.indexNote": "A tevékenységeid összefoglalóit indexeljük a gyors elérés érdekében.",
  "tab.profile.viewIndex": "Index megtekintése",
  "tab.profile.sharedMaps": "Megosztott térképek",
  "tab.profile.sharedMapsNote": "Ki: a Heatflaskon csak te láthatod a tevékenységeidet. Be: bárki, akinek megvan a térképed linkje, láthatja azokat a tevékenységeidet, amelyeket a Stravában nyilvánossá tettél. A privátak mindenképp a tieid maradnak. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Hogyan működik az adatvédelem</a>",
  "tab.profile.logout": "Kijelentkezés",
  "tab.profile.deleteAccount": "Fiók törlése",
  "tab.profile.deleteConfirm": "Törlöd a Heatflask-fiókodat?\n\nEzzel eltávolítjuk az indexelt tevékenységeidet, és visszavonjuk a Heatflask hozzáférését a Strava-adataidhoz. A művelet nem vonható vissza.",
  "tab.profile.languageHeading": "Nyelv",
  "tab.profile.languageAuto": "Automatikus",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Segíts kijavítani a fordításokat, vagy újakat hozzáadni!</a>",
  "tab.profile.unitsHeading": "Mértékegységek",
  "tab.profile.unitsAuto": "Automatikus",
  "tab.profile.unitsMetric": "Metrikus (km, m)",
  "tab.profile.unitsImperial": "Angolszász (mi, ft)",
  "tab.profile.textSizeHeading": "Szövegméret",
  "tab.profile.textSmaller": "Kisebb",
  "tab.profile.textReset": "Normál",
  "tab.profile.textLarger": "Nagyobb",
  "tab.profile.mapDefaultsHeading": "Térkép alapbeállításai",
  "tab.profile.mapDefaultsNote": "Ez az alaptérkép, domborzat és rétegbeállítás lesz az induló állapot, valahányszor olyan térképet nyitsz meg, amelynek linkje nem ad meg sajátot. Az általad megosztott linkek továbbra is pontosan azt mutatják, amit te látsz.",
  "tab.profile.mapDefaultsSave": "Mentés alapbeállításként",
  "tab.profile.mapDefaultsForget": "Elvetés",
  "tab.info.title": "Infó",
  "tab.info.controlsHeading": "Vezérlés",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + húzás",
  "tab.info.shiftDragDesc": "Tevékenységek kijelölése egy téglalapon belül. Érintőképernyőn előbb koppints a <i class=\"hf-object-group\"></i> gombra, majd húzz egy ujjal. Az utoljára kijelölt tevékenység megmutatja a részleteit, és a tevékenységlista odagörget hozzá.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + húzás",
  "tab.info.ctrlDragDesc": "A térkép forgatása és döntése 3D-ben, vagy használd két ujjad",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Oldalsáv megnyitása vagy bezárása",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Előző vagy következő lap",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Oldalsáv bezárása",
  "tab.info.liveUrlHeading": "Élő URL",
  "tab.info.liveUrlDesc": "A térképnézet és az animáció beállításai az oldal URL-jében tárolódnak, így bárki, akivel megosztod, ugyanazt a nézetet látja.",
  "tab.info.videoHeading": "Videóexportálás",
  "tab.info.videoDesc": "A <i class=\"hf-video-camera\"></i> gomb MP4-videóként rögzíti az animációt: koppints rá, igazítsd a keretet a térkép kívánt részére, majd koppints újra a felvételhez. Az animáció egy teljes köre kerül rögzítésre, így a videó zökkenőmentesen ismétlődik; a {max} másodpercnél hosszabb kört (ez a Strava által elfogadott leghosszabb videó) {max} másodpercnél levágjuk.",
  "tab.info.contributeHeading": "Közreműködés",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Támogatás a GitHubon",
  "tab.info.contactsHeading": "Kapcsolat",
  "map.basemapAndTerrain": "Alaptérkép és domborzat",
  "map.pauseAnimation": "Animáció szüneteltetése",
  "map.resumeAnimation": "Animáció folytatása",
  "capture.record": "Videó rögzítése ({period} mp-es kör)",
  "capture.recordTruncated": "Videó rögzítése (egy kör {period} mp; csak az első {max} mp kerül rögzítésre)",
  "capture.recordArea": "A kereten belüli terület rögzítése",
  "capture.stop": "Felvétel leállítása",
  "capture.selectionTooSmall": "a kijelölés túl kicsi",
  "capture.saved": "mentve: {name} ({size})",
  "capture.cancelled": "felvétel megszakítva",
  "capture.failed": "a felvétel sikertelen: {error}",
  "capture.loadingEncoder": "kódoló betöltése…",
  "capture.waitingForMap": "várakozás a térkép betöltésére…",
  "capture.encoding": "kódolás… {percent}%",
  "capture.finalizing": "befejezés…",
  "share.title": "Link megosztása ehhez a térképhez",
  "share.copied": "link másolva",
  "share.copiedUnshared": "link másolva – de a térképed nincs megosztva, így más nem tudja megnyitni. Ehhez kapcsold be a „Megosztott térképek” beállítást.",
  "share.unshared": "A térképed nincs megosztva, így más nem tudja megnyitni ezt a linket. Ehhez kapcsold be a „Megosztott térképek” beállítást.",
  "share.copyThis": "Másold ki ezt a linket:",
  "update.available": "Elérhető a Heatflask új verziója.",
  "update.reload": "Újratöltés",
  "import.title": "Importálás",
  "import.stop": "Leállítás",
  "import.stopping": "leállítás…",
  "import.contacting": "kapcsolódás a Stravához…",
  "import.countOf": "Tevékenységek: {received} / {total}",
  "import.count": "Tevékenységek: {received}",
  "import.waitStrava": "A Strava letöltési korlátja miatt szünetel eddig: {time}. Hagyd nyitva az oldalt; az újratöltés nem gyorsít rajta.",
  "import.waitRationed": "A mai gyors letöltések elfogytak. A többi lassabban folytatódik ekkor: {time}. Hagyd nyitva az oldalt.",
  "import.dailyLimit": "A Strava napi letöltési korlátja elfogyott. Próbáld újra ekkor: {time}.",
  "import.dailyRationed": "A mai Strava-letöltési kereted elfogyott. Próbáld újra ekkor: {time}.",
  "import.noActivitiesYet": "A Strava-fiókodban még nincs tevékenység. Rögzíts vagy tölts fel egyet a Stravába, és itt megjelenik.",
  "table.noActivities": "nincs tevékenység",
  "table.untitled": "(névtelen)",
  "activities.pageTitle": "{app} — Tevékenységindex",
  "activities.heading": "Tevékenységindex",
  "activities.fetching": "Tevékenységek lekérése...",
  "activities.rateLimit": "Elérted a Strava kéréskorlátját; folytatás ekkor: {time}",
  "activities.noData": "Sajnos nincs adat &#128577;",
  "activities.colServerCache": "Az útvonal a szerveren gyorsítótárazva (Mongo)",
  "activities.colBrowserCache": "Az útvonal ebben a böngészőben gyorsítótárazva",
  "activities.cachedServer": "A(z) {id} útvonala gyorsítótárazva van a szerveren",
  "activities.notCachedServer": "A(z) {id} útvonala nincs gyorsítótárazva a szerveren",
  "activities.cachedBrowser": "A(z) {id} útvonala gyorsítótárazva van ebben a böngészőben",
  "activities.notCachedBrowser": "A(z) {id} útvonala nincs gyorsítótárazva ebben a böngészőben",
  "sport.AlpineSki": "Alpesi síelés",
  "sport.BackcountrySki": "Túrasí",
  "sport.Badminton": "Tollaslabda",
  "sport.Basketball": "Kosárlabda",
  "sport.Canoeing": "Kenu",
  "sport.Cricket": "Krikett",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Tánc",
  "sport.EBikeRide": "E-bringázás",
  "sport.Elliptical": "Elliptikus tréner",
  "sport.EMountainBikeRide": "Elektromos MTB",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Gravelezés",
  "sport.Handcycle": "Kézi hajtású kerékpár",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Túrázás",
  "sport.IceSkate": "Korcsolyázás",
  "sport.InlineSkate": "Görkorcsolyázás",
  "sport.Kayaking": "Kajak",
  "sport.Kitesurf": "Kitesurf",
  "sport.MountainBikeRide": "Hegyi kerékpározás",
  "sport.NordicSki": "Sífutás",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Gyógytorna",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Kerékpározás",
  "sport.RockClimbing": "Sziklamászás",
  "sport.RollerSki": "Görsí",
  "sport.Rowing": "Evezés",
  "sport.Run": "Futás",
  "sport.Sail": "Vitorlázás",
  "sport.Skateboard": "Gördeszka",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Hótalpas túra",
  "sport.Soccer": "Labdarúgás",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Lépcsőzőgép",
  "sport.StandUpPaddling": "SUP",
  "sport.Surfing": "Szörfözés",
  "sport.Swim": "Úszás",
  "sport.TableTennis": "Asztalitenisz",
  "sport.Tennis": "Tenisz",
  "sport.TrailRun": "Terepfutás",
  "sport.Velomobile": "Velomobil",
  "sport.VirtualRide": "Virtuális kerékpározás",
  "sport.VirtualRow": "Virtuális evezés",
  "sport.VirtualRun": "Virtuális futás",
  "sport.Volleyball": "Röplabda",
  "sport.Walk": "Séta",
  "sport.WeightTraining": "Súlyzós edzés",
  "sport.Wheelchair": "Kerekesszék",
  "sport.Windsurf": "Windsurf",
  "sport.Workout": "Edzés",
  "sport.Yoga": "Jóga"
}
